import { Button } from "@shopify/polaris";

import React, { useMemo, useRef } from "react";
import { OpenDromoContainer, UploadFileSpan } from "../../styles";
import DromoUploader from "dromo-uploader-react";
import { MigrationTableAccess } from "@vendor-app/app/AdminRoute/AdminMigrationsRoute/Manual/stores/NewMigrationTable";
import { MigrationFileUploadAccess } from "@vendor-app/app/AdminRoute/AdminMigrationsRoute/Manual/stores/MigrationFileUpload";
import {
  blockedStatuses,
  dromoLicenseKey,
  dromoSchemaId,
} from "@vendor-app/app/AdminRoute/AdminMigrationsRoute/Manual/libs/utils/constants";

export const DromoContainer = () => {
  const files = MigrationTableAccess.useFiles();
  const tableActions = MigrationTableAccess.useActions();
  const uploadActions = MigrationFileUploadAccess.useActions();

  const isUploadingOrCommitting = useMemo(() => {
    return files.some(file => blockedStatuses.includes(file.status));
  }, [files]);
  const dromoRef = useRef<DromoUploader | null>(null);

  return (
    <div data-testid="manual-migration-upload-zone">
      <DromoUploader
        licenseKey={dromoLicenseKey}
        ref={dromoRef}
        onResults={async (data, metadata) => {
          await uploadActions.uploadFile(metadata.id!);
          await tableActions.fetchFiles();
        }}
        developmentMode={false}
        schemaId={dromoSchemaId}
      />
      <OpenDromoContainer>
        <Button size="large" disabled={isUploadingOrCommitting} primary onClick={() => dromoRef.current?.open()}>
          Import Data
        </Button>
        <UploadFileSpan>
          {isUploadingOrCommitting
            ? "Please wait while we process your last upload."
            : "Upload your CSV file using our importer"}
        </UploadFileSpan>
      </OpenDromoContainer>
    </div>
  );
};
